import button from './button.vue'
button.install = function (Vue) {
  Vue.component(button.name, button);
};
export default button



// WEBPACK FOOTER //
// ./src/ni-ui/button/index.js